import { Stack } from "@chakra-ui/react";
import { FC } from "react";
import {
  Control,
  FieldValues,
  UseFormResetField,
  UseFormWatch,
} from "react-hook-form";
import PersonalDataForm from "./PersonalDataForm";
import SystemDataForm from "./SystemDataForm";

interface UserSubmitFormProps {
  errors: any;
  control: Control<any>;
  isDisabled?: boolean;
  resetField: UseFormResetField<FieldValues>;
  isFormInitialized?: boolean;
  watch: UseFormWatch<FieldValues>;
  handlePasswordReset?: () => void;
}

const UserSubmitForm: FC<UserSubmitFormProps> = ({
  errors,
  control,
  isDisabled,
  resetField,
  isFormInitialized = true,
  watch,
  handlePasswordReset,
}) => {
  return (
    <>
      <Stack spacing={8}>
        <PersonalDataForm
          errors={errors}
          control={control}
          isDisabled={isDisabled}
          handlePasswordReset={handlePasswordReset}
        />
        <SystemDataForm
          errors={errors}
          control={control}
          watch={watch}
          isDisabled={isDisabled}
          resetField={resetField}
          isFormInitialized={isFormInitialized}
        />
      </Stack>
    </>
  );
};

export default UserSubmitForm;
